module.exports = __webpack_public_path__ + "img/hub.ff3c6f0e.jpg";